<template>
  <div style="height: 100%">
    <maintenance-planning-loading v-if="loading" />
    <template v-else>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import MaintenancePlanningLoading from './MaintenancePlanningLoading.vue';

export default {
  name: 'MaintenancePlanningIndex',
  components: {
    MaintenancePlanningLoading,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('webApp', ['config', 'storageLocation']),
  },
  async created() {
    this.loading = true;
    const config = localStorage.getItem(this.storageLocation.maintenancePlan);
    if (config) {
      this.setConfig(JSON.parse(config));
    } else {
      this.resetConfig();
    }
    await Promise.all([
      this.fetchMachines(),
      this.fetchSolutions(),
      this.fetchCrons(),
      this.fetchOperators(),
      this.fetchAssets(),
    ]);
    this.loading = false;
  },
  methods: {
    ...mapMutations('webApp', ['setConfig', 'resetConfig']),
    ...mapActions('webApp', ['getAppSchema']),
    ...mapActions('maintenancePlanning', [
      'fetchMachines',
      'fetchSolutions',
      'fetchCrons',
      'fetchOperators',
      'fetchAssets',
    ]),
  },
  watch: {
    config: {
      deep: true,
      handler(val) {
        localStorage.setItem(this.storageLocation.maintenancePlan, JSON.stringify(val));
      },
    },
  },
};
</script>
